import React from "react";

import { Chip } from "@mui/material";

import { globalStyle } from "components";

import { IStatusBadge } from "./interface";
import { Container } from "./styles";

export const StatusBadge: React.FC<IStatusBadge> = ({ id, label, type }) => {
  return (
    <Container id={id} data-testId={id}>
      <Chip
        className="chip_badge"
        label={label}
        sx={{ background: globalStyle.badge[type] }}
        color="primary"
      />
    </Container>
  );
};
